function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoTelegramColored = function SvgLogoTelegramColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-telegram-colored_svg__a",
    x1: 256,
    x2: 256,
    y1: 0,
    y2: 510.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41bce7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22a6dc"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {
      fill: "url(#logo-telegram-colored_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.6 147.3-45.7 230.5s-6.4 16-24 8.3l-105.5-80.9-38.4-18.5-64.6-21.7s-9.9-3.5-10.9-11.2 11.2-11.8 11.2-11.8l256.8-100.7c0-.1 21.1-9.4 21.1 6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2 375.2s-3.1-.3-6.9-12.4-23.3-76.1-23.3-76.1l155.1-98.5s9-5.4 8.6 0c0 0 1.6 1-3.2 5.4-4.8 4.5-121.8 109.7-121.8 109.7",
    style: {
      fill: "#d2e4f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.8 336.2-41.7 38.1s-3.3 2.5-6.8.9l8-70.7",
    style: {
      fill: "#b5cfe4"
    }
  }));
};
export default SvgLogoTelegramColored;